import React from 'react';
import ReactDOM from 'react-dom';
import Router from './router';
import './assets/css/index.css';
import Header from './component/header/';
import AuthWrapper from './auth/AuthWrapper';
import apiConfig from './config/config';
import RestClient from './service/rest-client';
import { NotificationContainer } from './component/utils/NotificationManager';

// Import Highcharts configuration to apply global settings
import './config/highcharts-config';

// App component to handle the integration between AuthWrapper and RestClient
class App extends React.Component {
    constructor(props) {
        super(props);
        this.authWrapperRef = null; // Use callback ref instead of createRef for React 15
    }

    componentDidMount() {
        // Connect REST client with AuthWrapper for session management
        if (this.authWrapperRef) {
            RestClient.setSessionExpiredCallback(
                this.authWrapperRef.handleSessionExpired
            );
        }
    }

    render() {
        return (
            <div>
                <AuthWrapper ref={(ref) => { this.authWrapperRef = ref; }}>
                    <div>
                        <Header></Header>
                        <div className="page-container">
                            <Router></Router>
                        </div>
                    </div>
                </AuthWrapper>
                <NotificationContainer position="top-right" />
            </div>
        );
    }
}

apiConfig.event.onFetchConfigData.add((data) => {
    if (data.status) {
        // Add body classes for proper layout
        document.body.className = 'page-header-fixed page-header-fixed-mobile';
        
        ReactDOM.render(
            <App />,
            document.getElementById('root')
        );
    }

    console.log("Environment");
    console.log(data.env);
});
